// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Input,
  Label,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  SelectInput,
  convertEventSelectToTarget,
} from '../../containers/componentsInjection';

export const ProposalsByPlanPage = ({
  plans,
  history,
  sellers,
  createData,
  validation,
  statusOptions,
  categoryPlans,
  resetPlanInput,
}) => {
  return (
    <PageWrapper title="Propostas por Plano">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label">Período por</Label>
                      <div className="d-flex justify-content-between align-items-center">
                        <Col>
                          <Input
                            id="periodTypeSale"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'sale'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'sale'}
                            onChange={(e) => {
                              if (e.target.value === 'sale') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'sale',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="periodTypeSale"
                            className="text-muted text-uppercase"
                          >
                            Data da Venda
                          </Label>
                        </Col>

                        <Col>
                          <Input
                            id="periodTypeCreated"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'created'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'created'}
                            onChange={(e) => {
                              if (e.target.value === 'created') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'created',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="periodTypeCreated"
                            className="text-muted text-uppercase"
                          >
                            Data da Vigência
                          </Label>
                        </Col>
                      </div>
                    </div>
                  </Col>

                  <Col md={4} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        Período
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="periodStarts"
                          value={validation.values.periodStarts}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />

                        <span className="m-2">a</span>

                        <Input
                          type="date"
                          id="periodEnds"
                          value={validation.values.periodEnds}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="sellerInput" className="form-label">
                        Corretor
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="sellerInput"
                        value={validation.values.sellerInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );

                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'sellerInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(sellers)}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="categoryPlanInput" className="form-label">
                        Categoria de Plano
                      </Label>
                      <SelectInput
                        isClearable
                        className="form-control"
                        inputId="categoryPlanInput"
                        value={validation.values.categoryPlanInput}
                        onChange={(eventInput) => {
                          resetPlanInput();

                          validation.handleChange(
                            convertEventSelectToTarget(
                              'categoryPlanInput',
                              eventInput
                            )
                          );

                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'categoryPlanInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'categoryPlanInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(categoryPlans)}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="planInput" className="form-label">
                        Plano
                      </Label>
                      <SelectInput
                        isDisabled={!validation.values.categoryPlanInput.value}
                        isClearable
                        className="form-control"
                        inputId="planInput"
                        value={validation.values.planInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget('planInput', eventInput)
                          );

                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'planInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget('planInput', eventInput)
                          );
                        }}
                        options={plans}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label
                        htmlFor="proposalSituationInput"
                        className="form-label"
                      >
                        Situação da Proposta
                      </Label>
                      <SelectInput
                        multiple
                        className="form-control"
                        inputId="proposalSituationInput"
                        value={validation.values.proposalSituationInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={statusOptions}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{
                        marginRight: '10px',
                      }}
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Gerar Relatório
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
